import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const PrivateRoute = ({isAuth, isAdmin = false, adminOnly = false}) => {
    if(process.env.NODE_ENV === 'development') {
        return <Outlet /> 
    }
    
    if (!isAuth) {
        return <Navigate to="/login" />;
    }

    if (adminOnly && !isAdmin) {
        return <Navigate to="/" />;
    }

    return <Outlet />;
}

export default PrivateRoute;
